module.exports = __webpack_public_path__ + "img/csa_button_chessieschallenge.75a1e2a2.png";